import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { DynamicTableRow } from '../dynamic-table-row';
import { IColumn, ICell , IRow } from '../../viewmodels/runnableLookups/icell';
import { LookupColumn } from './lookup-column';
import { LookupCell } from './lookup-cell';
export class LookupRow implements ViewModel, DynamicTableRow, IRow {
  readonly friendlyTypeNameSingular = 'Lookup Row';
  readonly apiRoute: string = CONFIG.apiRoutes.lookupRows;
  readonly type = 'user-defined';

  lookupRowId: string;
  rowIndex: number;
  columns: { [key: string]: LookupCell } = {};
  lookupId: string;

  addColumn(column: LookupColumn, cell: LookupCell) {
    if (this.columns[column.lookupColumnId]) {
      return;
    }

    this.columns[column.lookupColumnId] = cell;
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupRowId = data.lookupRowId;
    this.rowIndex = data.rowIndex;

    if (data.lookupCells) {
      data.lookupCells.forEach(cell => {
        const newCell = new LookupCell();
        newCell.loadFromJson(cell);
        this.columns[cell.lookupColumnId] = newCell;
      });
    }

    this.lookupId = data.lookupId;
  }
}
